<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div id="templatePane">
    <div class="hero-section" style="background-image:url(/static/images/hero-connection.png)">
      <div class="hero-section-text row column">
        <h1>Not so fast, we're not ready to connect you yet.</h1>
      </div>
    </div>
    <section id="mainContent" class="row column">
      <h2>Why can't I sign up now?</h2>
      <p>It's really great to see you're so keen!</p>
      <p>But we're staggering the sign up process in order to make sure it's as smooth as possible for everyone.  The great news is you'll receive an invite to join Workplace in the next few weeks.</p>
      
 
      <p>If you've access to the BT intranet, head to FixIT where we have <a href="https://fixit.bt.com/pages/browsebysubject.aspx?contentcenter=Workplace%20by%20Facebook">lots of articles</a> about Workplace.</p>
    </section>
  </div>
</template>

<script>
var ES6Promise = require("es6-promise")
ES6Promise.polyfill()
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
import {fixitContentCentre} from '../commonError'

export default {
  name: 'ErrorOUCNotEligible',
  title: "Workplace - Your OUC is not eligible yet",
    data: function() {
    return {
      bearerToken: "",
      fixitContentCentre: fixitContentCentre
    }
  }
}

</script>
